
(function ($) {
  //////////////////////////////////////////////////////////////////////////////
  //Compare Table
  //////////////////////////////////////////////////////////////////////////////
  //

  // to intitualize this plugin all you have to do is add this to your javascript file:
  $.fn.compareTable = function (options, callback) {
    var settings = $.extend({
      settingsOption: false
    }, options)

    $(this).each(function (e) {
      var theTable = $(this);
      theTable.find('table').before('<div class="compare-section"></div>')
      var compareSection = theTable.find('.compare-section');


      theTable.find('thead a').each(function () {
        var name = $(this).html();
        compareSection.append("<div class='checkbox'><input type='checkbox' name='" + name + "' aria-label='" + name + "' checked='true'><label><div class='icon-utility-close' aria-label='Close' role='img'></div><div class='icon-utility-check' aria-label='check' role='img'></div><span>" + name + "</span></label></div>");
        // compareSection.prepend("<h2 class='nothing-selected'>Please Select a Product</h2>");
      })
      var compareSectionInput = compareSection.find('input');



      compareSectionInput.on('click', function () {
        var name = $(this).attr('name');
        var number = theTable.find('thead a:contains("' + name + '")').parent().index() + 1;

        if (!($(this).prop('checked') && ($(this).attr('name') === name))) {

          theTable.find('thead th:nth-child(' + number + ')').hide();
          theTable.find('tbody tr td:nth-child(' + number + ')').hide();

        } else if (($(this).prop('checked') && ($(this).attr('name') === name))) {
          theTable.find('thead th:nth-child(' + number + ')').show();
          theTable.find('tr td:nth-child(' + number + ')').show();
        }





      })

      compareSection.on('click', function () {
        if (compareSectionInput.not(':checked').length == compareSectionInput.length) {
          theTable.find('table').addClass('hidden');
          theTable.find('.nothing-selected').show();
        } else {
          theTable.find('table').removeClass('hidden');
          theTable.find('.nothing-selected').hide();
        }

      });

      if (compareSectionInput.not(':checked').length == compareSectionInput.length) {
        theTable.find('table').addClass('hidden');
        theTable.find('.nothing-selected').show();
      } else {
        theTable.find('table').removeClass('hidden');
        theTable.find('.nothing-selected').hide();
      }

      compareSectionInput.click(function () {
        $(this).next().next().prop('disabled', !this.checked)


        if (theWindow.width() <= 1200 && theWindow.width() >= 900) {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 4);
        } else if (theWindow.width() <= 900 && theWindow.width() >= 600) {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 3);
        } else if (theWindow.width() <= 600 && theWindow.width() >= 400) {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 2);
        } else if (theWindow.width() <= 400 && theWindow.width() >= 1) {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 1);
        } else {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 99);
        }

      });

      theWindow.on('load window:resize', function () {

        if (theWindow.width() <= 1200 && theWindow.width() >= 900) {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 4);
        } else if (theWindow.width() <= 900 && theWindow.width() >= 600) {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 3);
        } else if (theWindow.width() <= 600 && theWindow.width() >= 340) {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 2);
        } else if (theWindow.width() <= 340 && theWindow.width() >= 250) {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 1);
        } else if (theWindow.width() > 1200) {
          theTable.find('thead th').show();
          theTable.find('tbody tr td').show();
        } else {
          compareSectionInput.not(':checked').prop('disabled', compareSection.find('input:checked').length == 99);
        }


        var number = compareSection.find('input:checked').last().parent().index() + 2;

        theTable.find('thead th:nth-child(' + number + ')').hide();
        theTable.find('tbody tr td:nth-child(' + number + ')').hide();

        if (theWindow.width() >= 1200) {
          compareSection.find('input').prop("checked", true);
        }

      });

      function uncheckLast(a) {
        if (a.matches) {

          compareSection.find('input:checked').last().prop("checked", false);
          var number = compareSection.find('input:checked').last().parent().index() + 2;

          theTable.find('thead th:nth-child(' + number + ')').hide();
          theTable.find('tbody tr td:nth-child(' + number + ')').hide();


        }
      }


      var width_1200 = window.matchMedia("(max-width: 1200px)")
      var width_900 = window.matchMedia("(max-width: 900px)")
      var width_600 = window.matchMedia("(max-width: 600px)")
      var width_400 = window.matchMedia("(max-width: 400px)")

      uncheckLast(width_1200)
      uncheckLast(width_900)
      uncheckLast(width_600)
      uncheckLast(width_400)


      width_1200.addListener(uncheckLast)
      width_900.addListener(uncheckLast)
      width_600.addListener(uncheckLast)
      width_400.addListener(uncheckLast)


    });
  }

  ///////////////////////////////////////////////////////////////////////////
  //Compare Table end                                          
  ///////////////////////////////////////////////////////////////////////////

})(jQuery); // or even jQuery.noConflict()